/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  responseTime: 0,
  isError: false,
  msgError: '',
};
export const headcountEmployeeTransferReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.HEADCOUNT_EMPLOYEE_TRANSFER + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.HEADCOUNT_EMPLOYEE_TRANSFER + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        responseTime: action.result.responseTime,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.HEADCOUNT_EMPLOYEE_TRANSFER + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
